import React from "react";
import PdfViewer from "../PdfViewer";
import PDF5 from "../pdf/MOG 231_PARTE GENERALE.pdf";
import "../App.css";

const App5 = () => (
  <div className="content">
    <p className="button-63" role="button">MOG 231 PARTE GENERALE</p>
    <PdfViewer pdf={PDF5} />
  </div>
);

export default App5;
